













































































































































import { namespace } from 'vuex-class';
import { Vue, Prop, Component } from 'vue-property-decorator';
import { Tooltip, Popover } from 'element-ui';
import { AcgnFormTitle } from '@/components';
import AcgnPopCard from './pop-card.vue';

const StatisticAction = namespace('desk/statistic').Action;

interface CardDetailType {
  task_group: any; // 话数
  task: any; // 任务数
  link: any; // 环节数
  cell: any; // 件数
  pass: any; // 审批通过
  examine: any; // 过审情况
  overdue: any; // 逾期情况
  target: any; // 目标情况
}

@Component({
  components: {
    AcgnFormTitle,
    AcgnPopCard,
    [Tooltip.name]: Tooltip,
    [Popover.name]: Popover
  }
})

/**
 * 项目总览卡片
 */
export default class AcgnStatisticCard extends Vue {
  public name: string = 'AcgnStatisticCard';

  @Prop({ default: null }) public comicId: number | null; // 项目id

  @Prop({ default: true }) public isShowTitle: boolean; // 是否显示标题

  @Prop({ default: false }) public isShowTarget: boolean; // 是否显示目标进度

  // 1：管理方-总览 2：管理方-项目
  @Prop({ default: 1 }) public routeType: number; // 用于区分数字点击跳转明细页面

  @StatisticAction private getManagerStatistics: any;

  private pop_1 =
    { title: '总话数', items: [{ name: '已完成', num: 0 }, { name: '缺稿', num: 0 }, { name: '缺失', num: 0 }] };
  private pop_2 =
    { title: '总任务数', items: [{ name: '已完成', num: 0 }, { name: '缺稿', num: 0 }, { name: '缺失', num: 0 }] };
  private pop_3 =
    { title: '总环节数', items: [{ name: '待提交', num: 0 }, { name: '已提交', num: 0 }] };
  private pop_4 =
    { title: '总件数', width: 240, items: [{ name: '审批通过', num: 0 }, { name: '审批未通过', num: 0 }] };

  private pop_11 =
    {
      title: '提交审批', width: 240, items: [{ name: '审批通过', num: 0 }, { name: '审批中', num: 0 },
      { name: '审批拒绝', num: 0 }, { name: '审批撤销', num: 0 }]
    };
  private pop_12 =
    { title: '审批通过', items: [{ name: '分镜稿', num: 0 }, { name: '勾线稿', num: 0 }] };
  private pop_13 =
    { title: '过审率', info: '审批通过次数/提交审批次数' };

  private pop_21 =
    { title: '逾期提交率', info: '逾期提交次数/提交审批次数', items: [{ name: '逾期提交', num: 0 }] };
  private pop_22 = { title: '逾期审批率', info: '逾期审批次数/提交审批次数', items: [{ name: '逾期审批', num: 0 }] };

  private pop_31 =
    { title: '目标达成率', info: '达成数/周期数', items: [{ name: '达成数', num: 0 }, { name: '周期数', num: 0 }] };

  // 1：管理方-总览 2：管理方-项目
  private detailRoute: any = {
    1: 'desk-statisticDetail',
    2: 'desk-statisticComicDetail'
  };

  private cardData: CardDetailType = {  // 卡片信息
    task_group: {}, // 话数
    task: {}, // 任务数
    link: {}, // 环节数
    cell: {}, // 件数
    pass: {}, // 审批通过
    examine: {}, // 过审情况
    overdue: {}, // 逾期情况
    target: {} // 目标情况
  };
  // private isShowAllDetail: boolean = false; // 是否显示查看全部

  // private get taskDetailList() {
  //   if (this.isShowAllDetail) {
  //     return this.cardData.task_detail;
  //   }
  //   return this.cardData.task_detail.slice(0, 5);
  // }

  private async created() {
    this.cardData = (await this.getManagerStatistics({
      project_id: this.comicId
    })).result;

    const group: any = this.cardData.task_group;
    const task: any = this.cardData.task;
    const link: any = this.cardData.link;
    const cell: any = this.cardData.cell;
    this.pop_1.items = [
      { name: '已完成', num: group['0'] },
      { name: '缺稿', num: group['1'] },
      { name: '缺失', num: group['2'] }
    ];
    this.pop_2.items = [
      { name: '已完成', num: task['0'] },
      { name: '缺稿', num: task['1'] },
      { name: '缺失', num: task['2'] }
    ];
    this.pop_3.items = [{ name: '待提交', num: link['0'] }, { name: '已提交', num: link['1'] }];
    this.pop_4.items = [{ name: '审批通过', num: cell['0'] }, { name: '审批未通过', num: cell['1'] }];

    const examine: any = this.cardData.examine;
    const pass: any = this.cardData.pass;
    this.pop_11.items =
      [{ name: '审批通过', num: examine['pass'] }, { name: '审批中', num: examine['in_approve'] },
      { name: '审批拒绝', num: examine['refuse'] }, { name: '审批撤销', num: examine['revoke'] }];
    this.pop_12.items = pass.task_detail.map((item: any) => {
      return { name: item.task_name, num: item.task_cnt };
    });

    const overdue: any = this.cardData.overdue;
    const target: any = this.cardData.target;
    this.pop_21.items = [{ name: '逾期提交', num: overdue['overdue'] }];
    this.pop_22.items = [{ name: '逾期审批', num: overdue['over_approve'] }];
    this.pop_31.items = [{ name: '达成数', num: target['finished'] }, { name: '周期数', num: target['cycle_num'] }];
  }

  private goDetail(type: string) {
    const name = this.detailRoute[this.routeType];
    const params: any = { type };
    if (this.comicId) {
      params.id = this.comicId;
    }
    this.$router.push({ name, params });
  }
}
